import React from 'react';

import ConceptHeader from './concept_header';
import PerformanceByConcept from './performance_by_concept';
import StatisticData from '../statistic_data';
import { ConceptData } from './types';

interface Props {
  filters: any;
  hideConceptsWithNoActivity: boolean;
}

const SectionConcepts: React.FC<Props> = (props) => {
  return (
    <div className="d-flex flex-column gap-s">
      <StatisticData
        filters={props.filters}
        name="performance_by_concept"
      >
        <StatisticData.Loading>
          {/* @ts-ignore */}
          <ConceptHeader section={props.filters.sections} />
          <div style={{ minHeight: 150 }} />
        </StatisticData.Loading>

        {/* @ts-ignore */}
        <ConceptHeader section={props.filters.sections} />
        {/* @ts-ignore */}
        <PerformanceByConcept
          hideConceptsWithNoActivity={props.hideConceptsWithNoActivity}
          period={props.filters.period}
          section={props.filters.sections}
        />
      </StatisticData>
    </div>
  );
};

export default SectionConcepts;
